import { createContext, useContext } from "react";

const CreateHotJarContext = createContext({});

export const CreateHotJarContextProvider = CreateHotJarContext.Provider;
export const CreateHotJarContextConsumer = CreateHotJarContext.Consumer;

export const useHotJarContext = () => useContext(CreateHotJarContext);

export default CreateHotJarContext;
